"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObjectInstanceHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class DataObjectInstanceHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings) {
        const url = this.buildUrl(index_1.restSettings.paths.getDataObjects, offset, limit, query, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            dataObjectInstances: response.result.dataObjectInstances.map(Mappers_1.mapDataObjectInstance),
        };
        return mappedResult;
    }
}
exports.DataObjectInstanceHttpClient = DataObjectInstanceHttpClient;
//# sourceMappingURL=DataObjectInstanceHttpClient.js.map